<template>
  <div class="wrapper index">
    <div class="video" v-if="isVideoShown">
      <video loop="loop" @click="isVideoShown = false"></video>
    </div>
    <!-- <video src="../../assets/video/bg.mp4" autoplay="autoplay" loop="loop"></video> -->




    <div class="main box-padding">
      <div class="col-xs-2"><a @click="$router.push({name: 'index'})"><img src="../../assets/img/main/logo-white.png" alt="念相" class="logo"></a></div>
      <div class="col-xs-pull-1 index-text-right">
        <div  class="index-change-lang">
          <a @click="changeLocale('en')" class="index-a">EN</a>
          <span>|</span>
          <a @click="changeLocale('zh_cn')" class="index-a">CN</a>
        </div>
        <img src="../../assets/img/icon/nav-white.png" alt="" class="nav-toggle" @click="openNav">
      </div>
      <div class="text col-xs-10 col-xs-offset-1">
        <ul>
          <li><img src="../../assets/img/index/text1-1.png" alt=""><div class="text1"></div></li>
          <li><img src="../../assets/img/index/text21.png" alt=""><div class="text2"></div></li>
          <li><img src="../../assets/img/index/text31.png" alt=""><div class="text3"></div></li>
          <li><img src="../../assets/img/index/text4-1.png" alt=""><div class="text4"></div></li>
        </ul>
        <img src="../../assets/img/index/text5-new.png" alt="" id="pc-big" class="pc-big">
        <img src="../../assets/img/mindex/text5-new.png" alt="" id="pc-small" class="pc-small">
      </div>
      <div class="index-bg">
        <img src="../../assets/img/index/bg-small.png" alt="">
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6" lang="babel">
  // mport $ from 'jquery';
  import hub from '../../utils/hub';

  export default {
    data() {
      return {
        isVideoShown: false
      };
    },
    // mounted() {
    //   // console.log($('video'));
    //   // setInterval(() => {
    //   //   $('video').attr('src', 'http://oib.oss-cn-beijing.aliyuncs.com/web/bg.mp4');
    //   //   $('video')[0].play();
    //   // }, 1000);
    // },
    methods: {
      openNav() {
        hub.$emit('open-nav');
      },
      changeLocale(lang) {
        this.$i18n.locale = lang;
        const { name } = this.$route;
        this.$router.push({ name, params: { lang } });
      }
    }
  };
</script>
<style type="text/css">
  .index-a{
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
    padding-top: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue